<template>
    <div class="card">
        <div class="card-header p-4"><h4>Detail</h4></div>
        <div class="card-body">
            <div class="row pt-2" :class="{'bg-light-light': key % 2 == 0}" v-for="(item, key) in items" :key="key">
                <label class="label label-primary">{{ key+1 }}</label>
                <br/>
                <div class="col-md-12">
                    <div class="row">
                        <div class="form-group col-md-6">
                            <label>Indikator *</label>
                            <select :id="`indicator_${key}`" :name="`indicator[${key}]`" class="form-control indicator" style="width:100%" v-model="item.indicator_id" v-select="item.indicator_id">
                            </select>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Target Indikator *</label>
                            <input :name="`target_indicator_label[${key}]`" class="form-control" placeholder="Eg: 75 < KRK ≤ 100" v-model="item.target_indicator_label" />
                        </div>
                        <div class="form-group col-md-2">
                            <label>Target Satuan *</label>
                            <input :name="`target_unit[${key}]`" class="form-control" placeholder="Eg: %, Hari" v-model="item.target_unit" />
                        </div>
                        <div class="form-group col-md-1">
                            <label>Urutan Form</label>
                            <input type="number" :name="`order[${key}]`" class="form-control" placeholder="Eg: 1-10" v-model="item.order" />
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th width="10%">#</th>
                                <th width="80%">Data yang dilaporkan</th>
                                <th width="10%">Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, i) in item.report_indicator_labels" :key="i">
                                <td>{{ alphabet(i) }}</td>
                                <td>
                                    <select :id="`report_indicator_${key}_${i}`" :name="`report_indicator[${i}]`" class="form-control report-indicator" style="width:100%" v-model="detail.report_indicator_id" v-select="detail.report_indicator_id">
                                    </select>
                                </td>
                                <td><button v-if="i>0" type="button" @click="removeDetail(item, item.report_indicator_labels, detail.key)" class="btn btn-icon btn-sm btn-clean"><i class="la la-trash text-danger"></i></button></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="3">
                                    <button type="button" @click="addNewDetail(item, key)" class="btn btn-success btn-sm"><i class="la la-plus"></i>&nbsp;&nbsp;Tambah Data</button>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <div class="row">
                                        <div class="form-group col-md-3">
                                            <label>Rumus Hasil (Label) *</label>
                                            <input :name="`result_label[${key}]`" class="form-control" v-model="item.result_label" placeholder="Eg: Dalam Persen" />
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label>Rumus *</label>
                                            <input :name="`result_formula[${key}]`" class="form-control" v-model="item.result_formula" placeholder="Eg: [A]/[B]" />
                                            <span class="form-text text-muted">Bila tidak ada rumus, cukup tulis [A]</span>
                                        </div>
                                        <div class="form-group col-md-5">
                                            <label>Keterangan Rumus</label>
                                            <template v-for="(detail, i) in item.report_indicator_labels">
                                                <span class="form-text text-muted" :key="i">[{{ alphabet(i) }}]: Pilihan pada tabel data yang dilaporkan nomor {{ alphabet(i) }}</span>
                                            </template>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <hr>
                </div>
            </div>

        </div>
        <div class="card-footer p-4">
            <button type="button" @click="addNew()" class="btn btn-success"><i class="la la-plus"></i>&nbsp;&nbsp;Tambah Formulir</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TemplateFormDataDetailForm',
        props: {
            save: Number,
            initialItems: Array
        },
        computed: {
        },
        data() {
            return {
                items: [],
                indicatorParameters: [
                    { id: '<', name: '<' },
                    { id: '<=', name: '<=' },
                    { id: '=', name: '=' },
                    { id: '>', name: '>' },
                    { id: '>=', name: '>=' },
                    { id: '!=', name: '≠' },
                ],
                resultParameters: [
                    { id: '/', name: 'Dibagi' },
                    { id: '*', name: 'Dikali' },
                    { id: '+', name: 'Dijumlah' },
                    { id: '-', name: 'Dikurang' },
                ]
            }
        },
        watch: {
            save(val) {
                this.$emit('items', this.items)
            }
        },
        mounted() {
            if(this.initialItems) {
                this.items = this.initialItems
                setTimeout(() => {
                    this.loadIndicators()
                    this.loadReportIndicators()
                    this.items.map((item, key) => {
                        $(`#indicator_${key}`)
                            .empty()
                            .append(`<option value="${item.indicator_id}">${item.indicator.name}</option>`)
                            .val(item.indicator_id)
                            .trigger('change')
                        item.report_indicator_labels.map((detail, i) => {
                            $(`#report_indicator_${key}_${i}`)
                                .empty()
                                .append(`<option value="${detail.report_indicator_id}">${detail.name}</option>`)
                                .val(detail.report_indicator_id)
                                .trigger('change')
                        })
                    })
                }, 300)
                console.log(this.items)
            }
        },
        methods: {
            addNew() {
                this.items.push({
                    key: Math.random(10),
                    indicator_id: null,
                    target_score: null,
                    target_indicator_label: null,
                    target_parameter: null,
                    target_unit: null,
                    target_score_min: null,
                    target_score_max: null,
                    target_parameter_min: null,
                    target_parameter_max: null,
                    result_label: null,
                    result_parameter: null,
                    target_formula: false,
                    result_formula: null,
                    order: null,
                    report_indicator_labels: [
                        { key: Math.random(10), report_indicator_id : null }
                    ]
                })
                setTimeout(() => {
                    this.loadIndicators()
                    this.loadReportIndicators()
                }, 300)
            },
            addNewDetail(item, key) {
                item.report_indicator_labels.push({
                    key: Math.random(10),
                    report_indicator_id : null
                })
                setTimeout(() => {
                    this.loadReportIndicators()
                }, 300)
            },
            removeDetail(item, report_indicator_labels, detailKey) {
                const fixDetails = report_indicator_labels.filter(val => val.key !== detailKey)
                item.report_indicator_labels = fixDetails
            },
            loadIndicators() {
                $('.indicator').select2({
                    placeholder: '-- Pilih salah satu --',
                    width: 'resolve',
                    ajax: {
                        url: '/ajax/dropdown-indicators',
                        dataType: "json",
                        type: "GET",
                        data: function (params) {
                            return {
                                search: params.term
                            }
                        },
                        processResults: function (data, page) {
                            return {
                                results: data
                            };
                        }
                    }
                })
            },
            loadReportIndicators() {
                $('.report-indicator').select2({
                    placeholder: '-- Pilih salah satu --',
                    width: 'resolve',
                    ajax: {
                        url: '/ajax/dropdown-report-indicators',
                        dataType: "json",
                        type: "GET",
                        data: function (params) {
                            return {
                                search: params.term
                            }
                        },
                        processResults: function (data, page) {
                            return {
                                results: data
                            };
                        }
                    }
                })
            }
        }
    }
</script>
